import { StepOutcome } from "components/CC/types/enums";
import { z } from "zod";

export const endFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    success: z.nativeEnum(StepOutcome),
});

export type EndFormData = z.infer<typeof endFormSchema>;
